exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  padding-top: 0px; }\n\n.reset-password-modal .btn {\n  height: 36px;\n  width: 95px;\n  border: 1px solid #0076CC;\n  border-radius: 100px;\n  background-color: #0076CC;\n  color: white; }\n\n.reset-password-modal .btn:hover {\n  background-color: #0086E6; }\n\n.reset-password-container .cancel-button {\n  margin-left: 15px; }\n\n.reset-failure {\n  color: #D31612;\n  font-size: 14px;\n  font-family: Roboto;\n  margin-bottom: 1rem; }\n\n.center-block {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.reset-success {\n  color: #1d850b;\n  font-size: 14px;\n  font-family: Roboto;\n  margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /azp/_work/1/s/src/app/auth/pages/reset-password.page.scss
// module id = ../../../../../src/app/auth/pages/reset-password.page.scss
// module chunks = main